import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parent-deliveries',
  templateUrl: './parent-deliveries.component.html',
  styleUrls: ['./parent-deliveries.component.scss']
})
export class ParentDeliveriesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
